<template>
    <div class="payments-calendar view-container">
        <div class="view-content">
            <action-bar title="calendário mensal" />

            <div class="grid">
                <div style="width: 800px">
                    <header class="menu-bar">
                        <balance-value title="Saldo previsto" :value="balanceCalendar()" />

                        <month-selector :hideButtons="hideButtons" @change-month="changeMonth" />

                        <custom-select :options="options" @update-option="updateOption" />
                    </header>

                    <transactions-list
                        :transactions="getLinkedTransactions(filter)"
                        @pay-calendar-transaction="payCalendarTransaction"
                    />
                </div>

                <summary-model header="" :tableData="_summaryData" :extraMargin="true">
                    <template #progress-bar>
                        <general-balance :summaryData="_summaryData" />
                    </template>
                </summary-model>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'pinia'
import { mainStore } from '../store'

import TransactionsList from '../components/lists/TransactionsList.vue'
import ActionBar from '../components/ActionBar.vue'
import MonthSelector from '../components/headers/MonthSelector.vue'
import BalanceValue from '../components/headers/transactions-screen/BalanceValue.vue'
import CustomSelect from '../components/inputs/CustomSelect.vue'
import SummaryModel from '../components/cards/summary-model/SummaryModel.vue'
import GeneralBalance from '../components/transactions-screen/GeneralBalance.vue'

import { summaryCalendar } from '../common/summary_configs'
import request from '../common/request'

export default {
    components: {
        ActionBar,
        TransactionsList,
        MonthSelector,
        BalanceValue,
        CustomSelect,
        SummaryModel,
        GeneralBalance,
    },

    name: 'PaymentsCalendar',

    data() {
        return {
            hideButtons: [true, false],
            options: [
                { label: 'Todas', value: 'all' },
                { label: 'Receitas', value: 'revenues' },
                { label: 'Despesas', value: 'expenses' },
            ],
            filter: undefined,
            modalOpen: false,
        }
    },

    computed: {
        ...mapState(mainStore, [
            '_date_selected',
            'getLinkedTransactions',
            'balanceCalendar',
            'findById',
            'isOttoFamily',
        ]),

        _summaryData() {
            return summaryCalendar()
        },
    },

    methods: {
        ...mapActions(mainStore, ['DISABLED', 'WAITING']),

        changeMonth(add) {
            if (add === 1) this.hideButtons = [false, true]
            else this.hideButtons = [true, false]

            this.DISABLED()
            this.WAITING(true)

            request.changeMonth(this._date_selected, undefined, false, this.isOttoFamily).finally(() => {
                this.DISABLED()
                this.WAITING()
            })
        },

        payCalendarTransaction(_id) {
            const data = { ...this.findById('linkedtransactions', _id) }

            if (data.lastPaymentDate) data.lastPaymentDate = ''
            else data.lastPaymentDate = new Date().toISOString()

            this.DISABLED()

            request.patch({ collection: 'linkedtransactions', data, _id }).finally(() => this.DISABLED())
        },

        updateOption(value) {
            if (value === 'all') this.filter = undefined
            else this.filter = { transactionType: value }
        },
    },
}
</script>

<style lang="scss" scoped>
.payments-calendar {
    .menu-bar {
        height: 55px;
        padding: 0px 20px 0px;
        margin-bottom: 20px;
        color: $text-black;
        border-top: solid 1px $title-grey;
        border-bottom: solid 1px $title-grey;
        border-radius: 2px;
        text-align: center;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
    }

    .grid {
        display: flex;
    }
}
</style>
